"use client";

import { useAppSelector } from "@/src/redux/hooks";
import { motion, AnimatePresence } from "framer-motion";

const Loading = () => {
  const { app_name } = useAppSelector((state) => state.setting);

  return (
    <div className="fixed inset-0 z-100 bg-sidebar dark:bg-dark-body flex items-center justify-center font-sans overflow-hidden">
      <AnimatePresence>
        <motion.div className="flex flex-col items-center gap-8">
          <div className="flex flex-col items-center gap-1">
            <motion.h1 className="text-4xl sm:text-5xl font-black tracking-tight text-slate-900 dark:text-white">
              {app_name || "Loading"}
              <span className="text-primary italic">.</span>
            </motion.h1>
            <motion.p className="text-[10px] uppercase tracking-[0.4em] font-bold text-slate-400 dark:text-slate-500 pl-1">
              One and only {app_name || "Loading"}
            </motion.p>
          </div>

          <div className="relative w-40 h-0.5 bg-slate-200 dark:bg-slate-800 rounded-full overflow-hidden border border-black/5 dark:border-white/5">
            <motion.div
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              className="absolute top-0 left-0 w-1/3 h-full bg-primary shadow-[0_0_15px_rgba(16,185,129,0.3)]"
            />
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Loading;
